import React, { useState, useRef, useEffect } from 'react'

import { connect } from 'react-redux'

import Form from 'components/form/form'

import {
	loginUser,
	joinAccount,
} from 'state/actions'

import { 
	getCurrentUser,
	getCurrentAccount,
} from 'state/selectors'

import { getUrlParams } from 'utils/text'

const Join = ({
    setStep,
    isActiveStep,
    userData,
    handleGoToDashboard,
    loginCredentials,
    closeCallback,
    refreshSlider,
    joinAccount,
    loginUser
}) => {
    const [formValues, setFormValues] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [formError, setFormError] = useState(null)

    const isGuest = false

    const currentUserRef = useRef(userData)
    const formValuesRef = useRef(formValues)
    const isActiveStepRef = useRef(isActiveStep)

    formValuesRef.current = formValues
    isActiveStepRef.current = isActiveStep
    currentUserRef.current = userData

    const account = userData ? (userData.invitedAccount || userData.authorisedAccount) : null

    const formRows = [
        [
            {
                key: 'account',
                type: 'accountBox',
                props: {
                    account: userData ? (userData.invitedAccount || userData.authorisedAccount) : null
                }
            }
        ]
    ]

    useEffect(() => {
        if(isActiveStep){
            setTimeout(() => {
                refreshSlider()
            },400)
        }
    }, [isActiveStep])

	const handleJoinAction = (e, didAccept) => {
        e.preventDefault()
        e.stopPropagation()

        const user = currentUserRef.current

        const {
            email,
            password
        } = loginCredentials || {}

		if(!didAccept){
            setStep(2)
		}else{
            setIsLoading(true)

			joinAccount(account.id, user.id, _ => {
				if(email && password){
					loginUser({ email, password }, (error, res) => {

                        setIsLoading(false)
                        handleGoToDashboard()
                        closeCallback()
					})
				}else{
                    setIsLoading(false)
                    handleGoToDashboard()
                    closeCallback()
				}
			})
		}
	}

    return (
        <React.Fragment>
            <Form
                rows={formRows}
                values={formValues}
                handleSubmit={e => handleJoinAction(e, true)}
                handleChange={() => {}}
                isLoading={isLoading}
                error={formError}
                isFocused={isActiveStep}
                buttonPrimary={{
                    label: 'Yep!',
                    icon: 'tick'
                }}
                buttonLow={{
                    label: `No thanks`,
                    callback: e => handleJoinAction(e, false)
                }}
            />
        </React.Fragment>
    )
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state, true),
        accountData: getCurrentAccount(state),
	}
}

export default connect(mapStateToProps, {
	loginUser,
	joinAccount,
})(Join)


// WEBPACK FOOTER //
// ./src/components/auth/register-modal/join.jsx